import { render, staticRenderFns } from "./IconGraduationCap.vue?vue&type=template&id=2a0570e5"
import script from "./IconGraduationCap.vue?vue&type=script&lang=js"
export * from "./IconGraduationCap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports